// 放一些公共方法之类的
import FJConfig from '@src/config/FJConfig.ts';
import FJNetworkManager from '@src/core/FJNetworkManager';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';

export class FJCommonAPIClass {
    protected _baseUrl: string;
    constructor() {
        this._baseUrl = FJConfig.BASE_URL;
    }

    protected _addTeamIdToFormData(formData: FormData) {
        if (FJRequirementsUtil.isTeamSpace()) {
            formData.append('tid', FJRequirementsUtil.getCurrentSpaceId());
        }
    }

    public async getAiExtensionInfo(eventId: string) {
        const url = this._baseUrl + 'v1/ai/get-ai-extension-info';
        const formData = new FormData();
        formData.append('event_id', eventId);
        this._addTeamIdToFormData(formData);
        const headers = {};
        FJNetworkManager._addUUID(headers);
        const options = {
            method: 'POST',
            body: formData,
            headers: headers,
        };
        const res = await fetch(url, options);
        const response = await res.json();
        const { data, code } = response;
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    }
}

const instance = new FJCommonAPIClass();
export default instance;
